import script from "./RecommendEditSupplierAnnounce.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecommendEditSupplierAnnounce.vue?vue&type=script&lang=ts&setup=true"

import "./RecommendEditSupplierAnnounce.vue?vue&type=style&index=0&id=7518bc42&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7518bc42"]])

export default __exports__